/**
 * Formats a phone number to (XXX) XXX-XXXX format
 * @param {string} phone - The phone number to format
 * @returns {string} - Formatted phone number
 */
export function formatPhoneNumber(phone) {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // If it's empty, return empty string
  if (cleaned.length === 0) return '';
  
  // If it's 10 digits, format as (XXX) XXX-XXXX
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  // If it's 11 digits and starts with 1, format as (XXX) XXX-XXXX
  if (cleaned.length === 11 && cleaned[0] === '1') {
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  
  // For other lengths, return the cleaned number
  return cleaned;
}

/**
 * Formats a phone number as the user types (for input fields)
 * @param {string} value - The current input value
 * @returns {string} - Formatted phone number
 */
export function formatPhoneInput(value) {
  if (!value) return '';
  
  // Remove all non-digit characters
  const cleaned = value.replace(/\D/g, '');
  
  // If it's empty, return empty string
  if (cleaned.length === 0) return '';
  
  // If it's 1-3 digits, return as is
  if (cleaned.length <= 3) {
    return cleaned;
  }
  
  // If it's 4-6 digits, add parentheses and space
  if (cleaned.length <= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  }
  
  // If it's 7-10 digits, add parentheses, space, and hyphen
  if (cleaned.length <= 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  // If it's 11 digits and starts with 1, format as (XXX) XXX-XXXX
  if (cleaned.length === 11 && cleaned[0] === '1') {
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  
  // For other cases, return the cleaned number
  return cleaned;
}

/**
 * Validates if a phone number is in the correct format
 * @param {string} phone - The phone number to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export function isValidPhoneNumber(phone) {
  if (!phone) return false;
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Must be 10 or 11 digits (11 if it starts with 1)
  return cleaned.length === 10 || (cleaned.length === 11 && cleaned[0] === '1');
}




